import React, { useState, useEffect } from 'react';
import { db, auth } from '../../firebase';
import { ref, onValue, update } from 'firebase/database';
import { useNavigate } from 'react-router-dom';
import { FaSearch, FaFilter, FaBuilding } from 'react-icons/fa';
import DetailModal from '../Incharge/DetailModal';

const AccountantSocietyList = () => {
    const [registrations, setRegistrations] = useState([]);
    const [loading, setLoading] = useState(true);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedTaluka, setSelectedTaluka] = useState('');
    const [selectedItem, setSelectedItem] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        const unsubscribe = auth.onAuthStateChanged((user) => {
            if (!user) navigate('/login');
        });

        const registrationsRef = ref(db, 'ekamwatapzp/SocietyRegistrations');
        const unsubData = onValue(registrationsRef, (snapshot) => {
            if (snapshot.exists()) {
                const data = snapshot.val();
                const list = Object.keys(data).map(key => ({
                    id: key,
                    ...data[key]
                }));
                setRegistrations(list.reverse());
            } else {
                setRegistrations([]);
            }
            setLoading(false);
        });

        return () => {
            unsubscribe();
            unsubData();
        };
    }, [navigate]);

    // Status update removed for Accountant role

    const filteredData = registrations.filter(item => {
        const searchSource = `${item.societyName} ${item.chairmanName}`.toLowerCase();
        const matchesSearch = searchSource.includes(searchTerm.toLowerCase());
        const matchesTaluka = selectedTaluka === '' || item.taluka === selectedTaluka;
        return matchesSearch && matchesTaluka;
    });

    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-600"></div>
            </div>
        );
    }

    return (
        <div className="p-8">
                <div className="mb-8 flex flex-col md:flex-row md:items-center justify-between gap-4">
                    <div>
                        <h1 className="text-2xl font-bold text-gray-800 tracking-tight flex items-center gap-3">
                            <FaBuilding className="text-amber-600" />
                            मजूर सहकारी संस्था यादी (Accountant Review)
                        </h1>
                        <p className="text-gray-500 font-bold mt-1 text-sm uppercase tracking-wider">लेखापाल पडताळणी: {filteredData.length} नोंदणी</p>
                    </div>
                </div>

                {/* Filters */}
                <div className="bg-white p-6 rounded-2xl shadow-sm border border-gray-100 mb-8 flex flex-col md:flex-row gap-4 items-center">
                    <div className="flex-grow relative w-full">
                        <FaSearch className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 text-sm" />
                        <input 
                            type="text" 
                            placeholder="शोध (संस्था / चेअरमेन)..." 
                            className="w-full pl-12 pr-4 py-3 rounded-xl border border-gray-100 bg-gray-50/50 focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 outline-none transition-all font-bold placeholder:text-gray-300"
                            value={searchTerm}
                            onChange={(e) => setSearchTerm(e.target.value)}
                        />
                    </div>
                    <div className="flex items-center space-x-3 w-full md:w-auto">
                        <FaFilter className="text-amber-600" />
                        <select 
                            className="bg-gray-50/50 border border-gray-100 rounded-xl px-4 py-3 outline-none focus:ring-2 focus:ring-blue-500/20 focus:border-blue-500 font-bold text-gray-600 w-full"
                            value={selectedTaluka}
                            onChange={(e) => setSelectedTaluka(e.target.value)}
                        >
                            <option value="">सर्व तालुके</option>
                            <option value="Miraj">मिरज</option>
                            <option value="Tasgaon">तासगाव</option>
                            <option value="Kavathe Mahankal">कवठे महांकाळ</option>
                            <option value="Walwa">वाळवा</option>
                            <option value="Shirala">शिराळा</option>
                            <option value="Khanapur">खानापूर</option>
                            <option value="Atpadi">आटपाडी</option>
                            <option value="Jat">जत</option>
                            <option value="Kadegaon">कडेगाव</option>
                            <option value="Palus">पलूस</option>
                        </select>
                    </div>
                </div>

                <div className="bg-white rounded-3xl shadow-sm border border-gray-100 overflow-hidden">
                    <div className="overflow-x-auto">
                        <table className="w-full text-left">
                            <thead className="bg-gray-50/50">
                                <tr>
                                    <th className="px-6 py-5 text-[10px] font-black uppercase tracking-widest text-gray-400 text-center w-16">#</th>
                                    <th className="px-6 py-5 text-[10px] font-black uppercase tracking-widest text-gray-400">संस्थेचे नाव</th>
                                    <th className="px-6 py-5 text-[10px] font-black uppercase tracking-widest text-gray-400">चेअरमेन</th>
                                    <th className="px-6 py-5 text-[10px] font-black uppercase tracking-widest text-gray-400">तालुका</th>
                                    <th className="px-6 py-5 text-[10px] font-black uppercase tracking-widest text-gray-400">नोंदणी क्र.</th>
                                    <th className="px-6 py-5 text-[10px] font-black uppercase tracking-widest text-gray-400 text-center">स्थिती</th>
                                    <th className="px-6 py-5 text-[10px] font-black uppercase tracking-widest text-gray-400 text-center">Admin Status</th>
                                    <th className="px-6 py-5 text-[10px] font-black uppercase tracking-widest text-gray-400 text-center">कृती</th>
                                </tr>
                            </thead>
                            <tbody className="divide-y divide-gray-50">
                                {filteredData.map((item, index) => (
                                    <tr key={item.id} className="hover:bg-amber-50/30 transition-colors group">
                                        <td className="px-6 py-6 text-center text-sm font-black text-gray-300 italic group-hover:text-amber-400">{index + 1}</td>
                                        <td className="px-6 py-6 font-bold text-gray-800">
                                            <div className="text-gray-900 group-hover:text-amber-600 transition-colors">{item.societyName}</div>
                                            <div className="text-[10px] text-gray-400 font-medium uppercase tracking-tighter shrink-0">{item.societyAddress}</div>
                                        </td>
                                        <td className="px-6 py-6">
                                            <div className="text-sm font-bold text-gray-700">{item.chairmanName}</div>
                                            <div className="text-[10px] text-amber-600 font-bold tracking-tighter shrink-0">{item.chairmanWhatsapp}</div>
                                        </td>
                                        <td className="px-6 py-6 text-sm font-bold text-gray-600">{item.taluka}</td>
                                        <td className="px-6 py-6 text-sm font-black text-gray-500 tracking-tighter">{item.registrationNo}</td>
                                        <td className="px-6 py-6 text-center">
                                            <span className={`px-4 py-2 rounded-2xl text-[10px] font-black border uppercase tracking-widest ${
                                                item.status === 'accepted' ? 'bg-green-50 text-green-600 border-green-100' : 
                                                item.status === 'rejected' ? 'bg-red-50 text-red-600 border-red-100' : 
                                                'bg-amber-50 text-amber-600 border-amber-100'
                                            }`}>
                                                {item.status === 'accepted' ? 'स्वीकारले' : item.status === 'rejected' ? 'नाकारले' : 'प्रलंबित'}
                                            </span>
                                        </td>
                                        <td className="px-6 py-6 text-center">
                                            <span className={`px-4 py-2 rounded-2xl text-[10px] font-black border uppercase tracking-widest ${
                                                item.adminStatus === 'Approved' ? 'bg-green-50 text-green-600 border-green-100' : 
                                                item.adminStatus === 'Rejected' ? 'bg-red-50 text-red-600 border-red-100' : 
                                                'bg-amber-50 text-amber-600 border-amber-100'
                                            }`}>
                                                {item.adminStatus === 'Approved' ? 'Accepted' : item.adminStatus === 'Rejected' ? 'Rejected' : 'Pending'}
                                            </span>
                                        </td>
                                        <td className="px-6 py-6 text-center">
                                            <button 
                                                onClick={() => {
                                                    setSelectedItem(item);
                                                    setIsModalOpen(true);
                                                }}
                                                className="bg-amber-600 hover:bg-amber-700 text-white text-[10px] font-black px-5 py-2.5 rounded-2xl transition-all shadow-lg shadow-amber-100 active:scale-95 uppercase tracking-widest border-2 border-white"
                                            >
                                                तपशील पहा
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                        {filteredData.length === 0 && (
                            <div className="p-20 text-center text-gray-300 font-black uppercase tracking-widest italic animate-pulse">
                                नोंदणी आढळली नाही.
                            </div>
                        )}
                    </div>
                </div>

                <DetailModal 
                    isOpen={isModalOpen} 
                    onClose={() => setIsModalOpen(false)} 
                    data={selectedItem} 
                    title="मजूर सहकारी संस्था नोंदणी पडताळणी"
                    registrations={registrations}
                />
            </div>
    );
};

export default AccountantSocietyList;
